import AccountDeleteForm from './account/account-delete-form.js';
import AccountEvents from './account/account-events.js';
import AccountRegister from './account/account-register.js';
import AccountSubscriptionsEditForm from './account/account-subscriptions-edit-form.js';
import AccountSubscriptionsEdit from './account/account-subscriptions-edit.js';
import AlertDeleteButton from './alert/alert-delete-button.js';
import AlertEditButton from './alert/alert-edit-button.js';
import AlertEditForm from './alert/alert-edit-form.js';
import AlertEvents from './alert/alert-events.js';
import AlertItem from './alert/alert-item.js';
import AlertMediator from './alert/alert-mediator.js';
import AlertRemoveForm from './alert/alert-remove-form.js';
import AlertsOverview from './alert/alerts-overview.js';
import AlertsSort from './alert/alerts-sort.js';
import AlertsTable from './alert/alerts-table.js';
import Announcements from './announcements.js';
import BrokerDropdown from './broker-dropdown.js';
import Carousel from './carousel.js';
import CookieNotification from './cookie-acceptance/cookie-notification.js';
import CookiePreferences from './cookie-acceptance/cookie-preferences.js';
import CopyValueButton from './copyValueButton.js';
import Dialog from './dialog.js';
import Dropdown from './dropdown.js';
import FlatexIframe from './flatex/iframe.js';
import CheckboxSelectionValidation from './form/checkbox-selection-validation.js';
import InputMatchesInput from './form/input-matches-input.js';
import InputValidation from './form/input-validation.js';
import PatternsValidator from './form/patterns-validator.js';
import FormFiltersReinitiate from './form-filters-reinitiate.js';
import Group from './group.js';
import Icon from './icon.js';
import Loader from './loader.js';
import Logo from './logo.js';
import MarketSentimentLarge from './market-sentiment/market-sentiment-large.js';
import Message from './message.js';
import Navigation from './navigation.js';
import PortfolioEvents from './portfolio/portfolio-events.js';
import PortfolioItemAddButton from './portfolio/portfolio-item-add-button.js';
import PortfolioItemEditForm from './portfolio/portfolio-item-edit-form.js';
import PortfolioItemRemoveForm from './portfolio/portfolio-item-remove-form.js';
import PortfolioItem from './portfolio/portfolio-item.js';
import PortfolioPerformance from './portfolio/portfolio-performance.js';
import PortfolioTable from './portfolio/portfolio-table.js';
import Portfolio from './portfolio/portfolio.js';
import PreferredBrokerSelector from './preferred-broker-selector.js';
import ProductChart from './product/product-chart.js';
import ProductDisclaimer from './product/product-disclaimer.js';
import ProductFiltersLinkedFields from './product/product-filters-linked-fields.js';
import ProductFiltersSlider from './product/product-filters-slider.js';
import ProductFilters from './product/product-filters.js';
import ProductMaximumLeverageExceeded from './product/product-maximum-leverage-exceeded.js';
import ProductTable from './product/product-table.js';
import CalculatorFormCappeFloore from './product-calculator/calculator-forms/calculator-form-cappe-floore.js';
import CalculatorFormEvents from './product-calculator/calculator-forms/calculator-form-events.js';
import CalculatorFormFactory from './product-calculator/calculator-forms/calculator-form-factory.js';
import CalculatorFormOptions from './product-calculator/calculator-forms/calculator-form-options.js';
import CalculatorFormPeriodSelector from './product-calculator/calculator-forms/calculator-form-period-selector.js';
import CalculatorFormTurboBooster from './product-calculator/calculator-forms/calculator-form-turbo-booster.js';
import CalculatorFormWarrants from './product-calculator/calculator-forms/calculator-form-warrants.js';
import CalculatorTableCappedBonus from './product-calculator/calculator-table/calculator-table-capped-bonus.js';
import CalculatorTableDefault from './product-calculator/calculator-table/calculator-table-default.js';
import CalculatorTableFactory from './product-calculator/calculator-table/calculator-table-factory.js';
import CalculatorTableWarrant from './product-calculator/calculator-table/calculator-table-warrant.js';
import CalculatorTable from './product-calculator/calculator-table/calculator-table.js';
import ProductCalculator from './product-calculator/product-calculator.js';
import ResponsiveTable from './responsive-table.js';
import Sidebar from './sidebar.js';
import TableResultsPerPage from './table-results-per-page.js';
import Tabs from './tabs.js';
import TickerElement from './ticker/ticker-element.js';
import TickerExtremes from './ticker/ticker-extremes.js';
import TickerPerformanceIndicator from './ticker/ticker-performance-indicator.js';
import Toggle from './toggle.js';
import Tooltip from './tooltip.js';
import TransactionLookupForm from './transaction-lookup/transaction-lookup-form.js';
import TransactionLookup from './transaction-lookup/transaction-lookup.js';
import TranslationsToggle from './translations-toggle.js';
import TurbomapEvents from './turbomap/turbomap-events.js';
import TurbomapHeader from './turbomap/turbomap-header.js';
import TurbomapNodeFactory from './turbomap/turbomap-node-factory.js';
import TurbomapPage from './turbomap/turbomap-page.js';
import TurbomapProductDetail from './turbomap/turbomap-product-detail.js';
import TurbomapVisual from './turbomap/turbomap-visual.js';
import Turbomap from './turbomap/turbomap.js';
import UnderlyingChart from './underlying/underlying-chart.js';
import UnderlyingMiniChart from './underlying/underlying-mini-chart.js';
import UnderlyingSentiment from './underlying/underlying-sentiment.js';
import UnderlyingOverviewFilters from './underlying-overview/underlying-overview-filters.js';
import UnderlyingOverviewItem from './underlying-overview/underlying-overview-item.js';
import UnderlyingOverviewTable from './underlying-overview/underlying-overview-table.js';
import UnderlyingOverview from './underlying-overview/underlying-overview.js';
import UnderlyingQuickLinks from './underlying-quick-links.js';
import UnderlyingSelectLink from './underlying-select-link.js';
import UnderlyingSelect, { SELECT_EVENT as UnderlyingSelectSelectEvent } from './underlying-select.js';
import UnderlyingTable from './underlying-table.js';
import YoutubeVideo from './youtube-video.js';
import WatchlistEvents from './watchlist/watchlist-events.js';
import WatchlistItemRemoveForm from './watchlist/watchlist-item-remove-form.js';
import WatchlistItemToggleButton from './watchlist/watchlist-item-toggle-button.js';
import WatchlistItem from './watchlist/watchlist-item.js';
import WatchlistTable from './watchlist/watchlist-table.js';
import Watchlist from './watchlist/watchlist.js';
import WebinarRegistration from './webinars/webinar-registration.js';
import WebinarPagination from './webinars/webinar-pagination.js';

const modules = {
	'account/account-delete-form': AccountDeleteForm,
	'account/account-events': AccountEvents,
	'account/account-register': AccountRegister,
	'account/account-subscriptions-edit-form': AccountSubscriptionsEditForm,
	'account/account-subscriptions-edit': AccountSubscriptionsEdit,
	'alert/alert-delete-button': AlertDeleteButton,
	'alert/alert-edit-button': AlertEditButton,
	'alert/alert-edit-form': AlertEditForm,
	'alert/alert-events': AlertEvents,
	'alert/alert-item': AlertItem,
	'alert/alert-mediator': AlertMediator,
	'alert/alert-remove-form': AlertRemoveForm,
	'alert/alerts-overview': AlertsOverview,
	'alert/alerts-sort': AlertsSort,
	'alert/alerts-table': AlertsTable,
	announcements: Announcements,
	'broker-dropdown': BrokerDropdown,
	carousel: Carousel,
	'cookie-acceptance/cookie-notification': CookieNotification,
	'cookie-acceptance/cookie-preferences': CookiePreferences,
	copyValueButton: CopyValueButton,
	dialog: Dialog,
	dropdown: Dropdown,
	'flatex/iframe': FlatexIframe,
	'form/checkbox-selection-validation': CheckboxSelectionValidation,
	'form/input-matches-input': InputMatchesInput,
	'form/input-validation': InputValidation,
	'form/patterns-validator': PatternsValidator,
	'form-filters-reinitiate': FormFiltersReinitiate,
	group: Group,
	icon: Icon,
	loader: Loader,
	logo: Logo,
	'market-sentiment/market-sentiment-large': MarketSentimentLarge,
	message: Message,
	navigation: Navigation,
	'portfolio/portfolio-events': PortfolioEvents,
	'portfolio/portfolio-item-add-button': PortfolioItemAddButton,
	'portfolio/portfolio-item-edit-form': PortfolioItemEditForm,
	'portfolio/portfolio-item-remove-form': PortfolioItemRemoveForm,
	'portfolio/portfolio-item': PortfolioItem,
	'portfolio/portfolio-performance': PortfolioPerformance,
	'portfolio/portfolio-table': PortfolioTable,
	'portfolio/portfolio': Portfolio,
	'preferred-broker-selector': PreferredBrokerSelector,
	'product/product-chart': ProductChart,
	'product/product-disclaimer': ProductDisclaimer,
	'product/product-filters-linked-fields': ProductFiltersLinkedFields,
	'product/product-filters-slider': ProductFiltersSlider,
	'product/product-filters': ProductFilters,
	'product/product-maximum-leverage-exceeded': ProductMaximumLeverageExceeded,
	'product/product-table': ProductTable,
	'product-calculator/calculator-forms/calculator-form-cappe-floore': CalculatorFormCappeFloore,
	'product-calculator/calculator-forms/calculator-form-events': CalculatorFormEvents,
	'product-calculator/calculator-forms/calculator-form-factory': CalculatorFormFactory,
	'product-calculator/calculator-forms/calculator-form-options': CalculatorFormOptions,
	'product-calculator/calculator-forms/calculator-form-period-selector': CalculatorFormPeriodSelector,
	'product-calculator/calculator-forms/calculator-form-turbo-booster': CalculatorFormTurboBooster,
	'product-calculator/calculator-forms/calculator-form-warrants': CalculatorFormWarrants,
	'product-calculator/calculator-table/calculator-table-capped-bonus': CalculatorTableCappedBonus,
	'product-calculator/calculator-table/calculator-table-default': CalculatorTableDefault,
	'product-calculator/calculator-table/calculator-table-factory': CalculatorTableFactory,
	'product-calculator/calculator-table/calculator-table-warrant': CalculatorTableWarrant,
	'product-calculator/calculator-table/calculator-table': CalculatorTable,
	'product-calculator/product-calculator': ProductCalculator,
	'responsive-table': ResponsiveTable,
	sidebar: Sidebar,
	'table-results-per-page': TableResultsPerPage,
	tabs: Tabs,
	'ticker/ticker-element': TickerElement,
	'ticker/ticker-extremes': TickerExtremes,
	'ticker/ticker-performance-indicator': TickerPerformanceIndicator,
	toggle: Toggle,
	tooltip: Tooltip,
	'transaction-lookup/transaction-lookup-form': TransactionLookupForm,
	'transaction-lookup/transaction-lookup': TransactionLookup,
	'translations-toggle': TranslationsToggle,
	'turbomap/turbomap-events': TurbomapEvents,
	'turbomap/turbomap-header': TurbomapHeader,
	'turbomap/turbomap-node-factory': TurbomapNodeFactory,
	'turbomap/turbomap-page': TurbomapPage,
	'turbomap/turbomap-product-detail': TurbomapProductDetail,
	'turbomap/turbomap-visual': TurbomapVisual,
	'turbomap/turbomap': Turbomap,
	'underlying/underlying-chart': UnderlyingChart,
	'underlying/underlying-mini-chart': UnderlyingMiniChart,
	'underlying/underlying-sentiment': UnderlyingSentiment,
	'underlying-overview/underlying-overview-filters': UnderlyingOverviewFilters,
	'underlying-overview/underlying-overview-item': UnderlyingOverviewItem,
	'underlying-overview/underlying-overview-table': UnderlyingOverviewTable,
	'underlying-overview/underlying-overview': UnderlyingOverview,
	'underlying-quick-links': UnderlyingQuickLinks,
	'underlying-select-link': UnderlyingSelectLink,
	'underlying-select': UnderlyingSelect,
	'underlying-select/SELECT_EVENT': UnderlyingSelectSelectEvent,
	'underlying-table': UnderlyingTable,
	'youtube-video': YoutubeVideo,
	'watchlist/watchlist-events': WatchlistEvents,
	'watchlist/watchlist-item-remove-form': WatchlistItemRemoveForm,
	'watchlist/watchlist-item-toggle-button': WatchlistItemToggleButton,
	'watchlist/watchlist-item': WatchlistItem,
	'watchlist/watchlist-table': WatchlistTable,
	'watchlist/watchlist': Watchlist,
	'webinars/webinar-registration': WebinarRegistration,
	'webinars/webinar-pagination': WebinarPagination,
};

export default modules;
